import { handleActions } from 'redux-actions';

export const initialState = {
  id: '',
  body: undefined,
  options: {},
};

const dialog = handleActions(
  {
    OPEN_DIALOG: (state, { payload: { id, body, options } }) => ({
      ...state,
      id,
      body,
      options,
    }),
    CLOSE_DIALOG: state => ({ ...state, ...initialState }),
    AUTHENTICATION_LOGOUT: () => ({
      ...initialState,
    }),
  },
  initialState,
);

export default dialog;



// WEBPACK FOOTER //
// ./src/store/reducers/Dialog/index.js